export type BatchFileUploadStatus = "pending" | "uploading" | "done" | "error";

export type BatchUploadProgress = {
  current: number;
  total: number;
  items: Array<{
    fileName: string;
    status: BatchFileUploadStatus;
  }>;
};

export function getBatchUploadDisplayCurrent(
  progress: BatchUploadProgress,
): number {
  const isUploading = progress.items.some((i) => i.status === "uploading");
  return progress.current + (isUploading ? 1 : 0);
}
